import { reactive } from 'vue';

// Module singleton: the listing page mounts several independent Vue apps, so
// props cannot cross app boundaries. Starts as loading because the page always
// searches on load; the debounce gap would otherwise flash the empty state.
const results = reactive({
  meta: null,
  results: [],
  markers: [],
  upcomingMarkers: [],
  loading: true,
  loadingMore: false,
  error: null
});

// Requests are not cancelled, so a slow one can resolve after a newer one was
// already started. Every start hands out a token; a payload only lands while
// its token is still the newest.
let currentRequest = 0;

const isStale = (token) => token !== currentRequest;

export const useResults = () => ({
  results,
  setLoading: () => {
    currentRequest += 1;
    results.loading = true;
    results.loadingMore = false;
    results.error = null;
    return currentRequest;
  },
  setData: (token, { meta, results: items, map }) => {
    if (isStale(token)) return;
    results.meta = meta || null;
    results.results = items || [];
    results.markers = map?.markers || [];
    results.upcomingMarkers = map?.upcomingMarkers || [];
    results.loading = false;
    results.loadingMore = false;
    results.error = null;
  },
  setLoadingMore: () => {
    currentRequest += 1;
    results.loadingMore = true;
    return currentRequest;
  },
  appendData: (token, { meta, results: items }) => {
    if (isStale(token)) return;
    results.meta = meta || results.meta;
    results.results.push(...(items || []));
    results.loadingMore = false;
  },
  stopLoadingMore: () => {
    results.loadingMore = false;
  },
  setError: (token, error) => {
    if (isStale(token)) return;
    results.loading = false;
    results.loadingMore = false;
    results.error = error;
  }
});
